<h2 mat-dialog-title>
    {{title}}
</h2>

<mat-dialog-content>
    <div>{{content}}</div>
</mat-dialog-content>

<mat-dialog-actions>
    <command-bar [commands]="commands">
    </command-bar>
</mat-dialog-actions>


<busy-indicator *ngIf="isProcessing" [page]="true"></busy-indicator>